import axios from "axios";
import React, { useContext, useState } from "react";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import Badge from "@mui/material/Badge";
import { RoleContext } from "../RoleContext";
import { Link } from "react-router-dom";
import Table from "../Theme/Table";
import { UserContext } from "../UserContext";
import Button from "../Theme/Button";
import Edit from "./Edit";
function AgentRegisteredDrivers({ drivers, getDrivers }) {
  const edit = "driver";
  const detail = "viewDriver";

  const [id, setId] = useState(null);

  const [deleteMessage, setDeleteMessage] = useState(null);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);

  const params = useParams();
  const roleData = useContext(RoleContext);
  const userData = useContext(UserContext);
  const [data, setData] = useState(null);

  var role = JSON.parse(roleData);

  const [displayAddCreditModal, setDisplayAddCreditModal] = useState(false);
  const showAddCreditModal = (id) => {
    let roleId = JSON.parse(localStorage.getItem("userData")).roleId;
    if (roleId === 30 || roleId === 31) {
      setId(roleId);
    } else {
      setId(id);
    }

    axios
      .get("/driver/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      })
      .then((res) => {
        setData(res.data.driver);
        setDisplayAddCreditModal(true);
      });
  };

  const [displayEditModal, setDisplayEditModal] = useState(false);
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  const showAddModal = () => {
    setDisplayAddModal(true);
  };

  const showDeleteModal = (id, name) => {
    setId(id);
    setDeleteMessage(`Are you sure you want to delete this driver`);
    setDisplayConfirmationModal(true);
  };
  const showEditModal = (id) => {
    setId(id);
    console.log("========byagent========", id);

    axios
      .get("/driver/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      })
      .then((res) => {
        setData(res.data.driver);
        setDisplayEditModal(true);
      });
  };

  const notify = () =>
    toast.success("Drivers list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        columns: [
          {
            Header: "ID",
            accessor: "id",
          },
          {
            Header: "First Name",
            accessor: "firstName",
          },
          {
            Header: "Last Name",
            accessor: "lastName",
          },
          {
            Header: "Gender",
            accessor: "gender",
          },
        ],
      },
      {
        Header: "Info",
        columns: [
          {
            Header: "Phone",
            accessor: "phoneNumber",
          },
          {
            Header: "Address",
            accessor: "address",
          },
          {
            Header: "Rating",
            accessor: "rating",
          },
          {
            Header: "Balance",
            accessor: "balance",
          },
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,

            Cell: (row) => (
              <div>
                {(() => {
                  if (row.cell.row.original.status == "Active") {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="success"
                      >
                        {" "}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="warning"
                      >
                        {" "}
                      </Badge>
                    );
                  }
                })()}
              </div>
            ),
          },
          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div>
                {role.filter(function (e) {
                  return e.perm_name === "add_driver_pocket";
                }).length > 0 && (
                  <Link
                    to={""}
                    onClick={(e) =>
                      showAddCreditModal(row.cell.row.original.id)
                    }
                  >
                    <i className="fas fa-dollar-sign success" />
                  </Link>
                )}
                &nbsp;
                {role.filter(function (e) {
                  return e.perm_name === "edit_driver";
                }).length > 0 && (
                  <Link
                    to={""}
                    onClick={(e) => showEditModal(row.cell.row.original.id)}
                  >
                    <i className="fas fa-edit info" />
                  </Link>
                )}
                &nbsp;
                {role.filter(function (e) {
                  return e.perm_name === "view_driver";
                }).length > 0 && (
                  <Link to={"/" + detail + "/" + row.cell.row.original.id}>
                    <i className="fas fa-eye success" />
                  </Link>
                )}
                &nbsp;
                {role.filter(function (e) {
                  return e.perm_name === "delete_driver";
                }).length > 0 && (
                  <Link
                    to={""}
                    onClick={(e) => showDeleteModal(row.cell.row.original.id)}
                  >
                    <i className="fas fa-trash error" />
                  </Link>
                )}
              </div>
            ),
          },
        ],
      },
    ],
    []
  );

  return (
    <div className="col-11">
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Registered Drivers</h3>
        
              <Link to={"/addDriverAsSubAgent"}  className="btn btn-success bt">
                    

                      <p>  <i class="nav-icon fas fa-plus"></i>Add Driver</p>
                    </Link>
      
        </div>

        <div className="card-body">
          <Table columns={columns} data={drivers} edit={edit} detail={detail} />
        </div>
      </div>
      {displayEditModal === true && (
        <Edit
          showModal={displayEditModal}
          hideModal={hideEditModal}
          id={id}
          data={data}
          getDrivers={getDrivers}
        />
      )}
    </div>
  );
}

export default AgentRegisteredDrivers;
